import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  // Número do WhatsApp (formato internacional sem + e sem espaços)
  const whatsappNumber = '5553981146431';
  
  // Mensagem padrão
  const defaultMessage = 'Olá! Gostaria de saber mais informações sobre os leilões da Knorr.';
  
  const handleWhatsAppClick = () => {
    // URL do WhatsApp Web/App
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;
    
    // Abre em nova aba
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {/* Botão flutuante do WhatsApp */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={handleWhatsAppClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full p-4 shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 ease-in-out"
          aria-label="Entrar em contato via WhatsApp"
          title="Fale conosco pelo WhatsApp"
        >
          <MessageCircle className="h-6 w-6 md:h-7 md:w-7" />
        </button>
        
        {/* Tooltip animado */}
        <div 
          className={`absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg whitespace-nowrap transform transition-all duration-200 ${
            isHovered 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-1 pointer-events-none'
          }`}
        >
          Fale conosco pelo WhatsApp
          {/* Seta do tooltip */}
          <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
        </div>
      </div>
      
      {/* Versão mobile - botão menor e posicionamento ajustado */}
      <style jsx>{`
        @media (max-width: 768px) {
          .fixed.bottom-6.right-6 {
            bottom: 1rem;
            right: 1rem;
          }
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;